import React from "react";
import { Constantes, GaUtils } from "@common/utils";
import { ChevronRight } from "@mui/icons-material";
import { useCurrentMenu } from "../../store/menu-app-context";

export const BackMenuButton = () => {
    const { setCurrentMenu } = useCurrentMenu();

    const onClick = () => {
        GaUtils.trackGAEvent(
            Constantes.GA_CATEGORY_EVENTS.CATEGORY_EVENT_NEW_UNIFIED_MENU,
            Constantes.GA_ACTION_EVENTS.EVENT_CHANGE_TO_OLD_MENU,
            Constantes.GA_LABELS_EVENTS.MENU_BAR_LEFT
        );

        setCurrentMenu("OLD");
    };

    return (
        <div className={"backMenuButton"} onClick={onClick}>
            <span className={"buttonLabel"}>Ir al menú anterior</span>
            <ChevronRight />
        </div>
    );
};
